import type { DatiPeriodo } from './ingresso'
import type { QuadroModello, RigaMutabile } from './modello'
import type { RegolePeriodo } from './regole-periodo'

export type QuadriInCostruzione = Partial<Record<QuadroModello, RigaMutabile[]>>

export function ambitoDi(dati: DatiPeriodo, regole: RegolePeriodo): number {
  return regole.ambiti.perProvincia[dati.provincia] ?? regole.ambiti.predefinito
}

export function aggiungiRiga(
  q: QuadriInCostruzione,
  esclusi: ReadonlySet<QuadroModello>,
  quadro: QuadroModello,
  riga: RigaMutabile,
): void {
  if (esclusi.has(quadro)) return
  ;(q[quadro] ??= []).push(riga)
}
